import React from 'react'

function Jan17blog() {
  return (
    <div>
      <h1>Nutrition Fellowship for Nepal : 2nd meet blog</h1>
      <h1>Coming soon.....</h1>
    </div>
  )
}

export default Jan17blog
